import AssetFilterEnum from 'redpoints-model-js/enumeration/AssetFilterEnum';
import AssetsRequestFilter from 'redpoints-model-js/model/filter/AssetsRequestFilter';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import AssetController from 'rpc-restapi-connector/controller/AssetController';
import AuditAssetReportController from 'redpoints-restapi-connector/controller/AuditAssetReportController';

import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CLEAR_COMPLETED,
  AUDIT_RESULTS_CLEAR_FILTERS,
  AUDIT_RESULTS_CREATE_INCIDENTS,
  AUDIT_RESULTS_FETCH_AUDITOR_ASSETS,
  AUDIT_RESULTS_FETCH_COMPLETED_AUDIT,
  AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON,
  AUDIT_RESULTS_SAVE_ASSET_AUDIT,
  AUDIT_RESULTS_SET_APPLIED_AUDITOR_ASSET_ID,
  AUDIT_RESULTS_SET_SELECTED_AUDITOR_ASSET_ID,
  CONNECTOR_REQUEST,
} from './actionTypes';
import { translate } from '../helpers/languageHelper';
import { buildPageable } from '../helpers/paginationHelper';

export const auditResultsClear = () => ({
  type: AUDIT_RESULTS_CLEAR,
});

export const auditResultsClearCompleted = () => ({
  type: AUDIT_RESULTS_CLEAR_COMPLETED,
});

export const auditResultsClearFilters = () => ({
  type: AUDIT_RESULTS_CLEAR_FILTERS,
});

export const auditResultsCreateIncidents = ({ auditAssetId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: AUDIT_RESULTS_CREATE_INCIDENTS,
    connectorMethod: AuditAssetReportController.createMissingIncidents,
    sortedParameters: [auditAssetId],
    expectedStatus: HttpStatus.NO_CONTENT,
  },
});

export const auditResultsFetchAuditorAssets = () => {
  const full = false;
  const all = undefined;
  const filters = new AssetsRequestFilter();
  filters.assetFilter = AssetFilterEnum.ONLY_AUDIT_ASSETS;
  filters.all = true;

  return {
    type: CONNECTOR_REQUEST,
    meta: {
      requestType: AUDIT_RESULTS_FETCH_AUDITOR_ASSETS,
      connectorMethod: AssetController.list,
      sortedParameters: [full, all, filters],
      expectedStatus: HttpStatus.OK,
    },
  };
};

export const auditResultsFetchCompletedAudit = ({ auditAssetId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: AUDIT_RESULTS_FETCH_COMPLETED_AUDIT,
    connectorMethod: AuditAssetReportController.exists,
    sortedParameters: [auditAssetId],
    expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND],
  },
});

export const auditResultsFetchIncidentsComparison = ({
  auditAssetId,
  pageable = buildPageable(),
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON,
    connectorMethod: AuditAssetReportController.compare,
    sortedParameters: [auditAssetId, pageable],
    expectedStatus: HttpStatus.OK,
  },
});

export const auditResultsSaveAssetAudit = ({
  auditAssetId,
  pageable = buildPageable(),
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: AUDIT_RESULTS_SAVE_ASSET_AUDIT,
    connectorMethod: AuditAssetReportController.generate,
    sortedParameters: [auditAssetId, pageable],
    expectedStatus: HttpStatus.CREATED,
    errorMessage: translate('auditResults.saveResults.errorMessage'),
    errorDescription: translate('auditResults.saveResults.errorDescription'),
  },
});

export const auditResultsSetAppliedAuditorAssetId = ({ assetId }) => ({
  type: AUDIT_RESULTS_SET_APPLIED_AUDITOR_ASSET_ID,
  payload: { assetId },
});

export const auditResultsSetSelectedAuditorAssetId = ({ assetId }) => ({
  type: AUDIT_RESULTS_SET_SELECTED_AUDITOR_ASSET_ID,
  payload: { assetId },
});
